import req from './req'

//获取企业微信注册地址
export function QWAuth (params) {
  return req.get('/workwechat/get-register-url', params)
}

//授权登录-预登录接口
export function preLogin (params) {
  return req.post('/authorized-login/pre-login', params)
}

//授权登录-关联shopexid
export function loginBind (params) {
  return req.post('/authorized-login/bind', params)
}


// 获取短信验证码（阿里云验证码2.0 时需传 captchaVerifyParam，由服务端配合 VerifyIntelligentCaptcha）
export function phoneCode (params) {
  return req.post('/authorized-login/send-mobile-code', params)
}


//获取企业微信登录地址
export function QWLogin (params) {
  return req.get('/authorized-login/get-url', params)
}
//获取授权第三方应用
export function QWD3Auth (params) {
  return req.get('/workwechat/get-auth-url', params)
}
//部分更新配置详情接口
export function QWUpdateConfig (params) {
  return req.post('/setting/workwechat/update-config', params)
}
//查询企业微信配置
export function QWConfig (params) {
  return req.get('/setting/workwechat', params)
}

//临时授权码获取永久授权
export function QWSetAuth_code (params) {
  return req.get('/workwechat/get-permanent-code?auth_code=123456', params)
}

//获取jssdk授权信息
export function getJssdkAuth (params) {
  return req.get('/workwechat/system-auth', params)
}

/**
 * 雪峰企微接口
 */

//录入企微第三方app配置项
export function setOpenworkwechat (params) {
  return req.post('/setting/openworkwechat', params)
}

//获取企微第三方app配置项
export function getOpenworkwechat (params) {
  return req.get('/setting/openworkwechat', params)
}

//初始化配置信息接口
export function getInitInfo (params) {
  return req.get('/setting/init-info', params)
}


// 获取授权开发二维码
// https://ecshopx2-ba.shopex123.com/endapi/workwechat/get-customized-auth-url
export function getQWQrode (params) {
  return req.post('/workwechat/get-customized-auth-url', params)
}
